import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import AppointmentService from '../utils/AppointmentService.js';
import "../CSS/credit_cards.css"
import CirclePlus from '../images/dbplus@3x.png'
import NewCCForm from './NewCCForm.js'
import Modal from 'react-modal'
import Visa from '../images/visa.png';
import Mastercard from '../images/mastercard.png';
import Discover from '../images/discover.png';
import Amex from '../images/amex.png';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';

const override = css`
    position:relative;
    z-index: 1000
`;
class CreditCards extends Component {
  constructor(props){
    super()
    this.state = {
      creditCards: [],
      creditCardsHTML: [],
      openModal: false,
      width: document.body.clientWidth,
      ccErrors: '',
      isLoading: false,
      errorMessage: '',
      color: '#green',
      open: false,
      openLoadingModal: false
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.saveCard = this.saveCard.bind(this)
    //this.getCreditCards = this.getCreditCards(this)
  }
  componentDidMount(){
    window.addEventListener("resize", this.updateDimensions);
    this.loadCards()
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  loadCards() {
    this.Appt = new AppointmentService()

      this.Appt.creditCards()
      .then(res =>{
        this.setState({
          open: false,
          errorMessage: ''
        })
        if(res.credit_cards){
          var parentThis = this
          var creditCardsHTML = []
          res.credit_cards.forEach(function(card){
            creditCardsHTML.push(<li key ={card.id} id={"card" + card.id} className="list-group-item ccListItem">
                                  { card.brand == "Visa" &&
                                      <img className="float-left mr-3 list-icon" src={Visa}></img>
                                  }
                                  { card.brand == "Discover" &&
                                      <img className="float-left mr-3 list-icon" src={Discover}></img>
                                  }
                                  { card.brand == "MasterCard" &&
                                      <img className="float-left mr-3 list-icon" src={Mastercard}></img>
                                  }
                                  { card.brand == "American Express" &&
                                      <img className="float-left mr-3 list-icon" src={Amex}></img>
                                  }
                                  **** **** **** {card.last4}<br></br>{card.exp_month}/{card.exp_year}
                                  { card.default_card == true &&
                                    <div className = "bottomButtons2">
                                      <button className="btn btn-block cancelButtonFlex2 text-center" onClick={() => parentThis.deleteCard(card.id)}>Delete</button>
                                    </div>
                                  }
                                  { card.default_card == false &&
                                    <div className = "bottomButtons2">
                                      <button className="btn successButtonFlex2 btn-block text-center" type="submit" onClick={() => parentThis.setAsDefault(card.id)}>Set as Default</button>
                                      <button className="btn btn-block cancelButtonFlex2 text-center" onClick={() => parentThis.deleteCard(card.id)}>Delete</button>
                                    </div>
                                  }
                                </li>)
          });
          this.setState({
            creditCardsHTML: creditCardsHTML
          })
        }
      })
      .catch(err =>{
        throw new Error('Error getting credit cards' + err.message);
        this.setState({
          open: true,
          color: '#c42d2d',
          errorMessage: 'Could not retrieve cards'
        })
      })
  }
  setAsDefault(cardId) {
    var parentThis = this
    this.setState({
      openLoadingModal:true
    })
    this.Appt.setDefaultCard(cardId)
    .then( res => {
      this.setState({
        open: true,
        color: 'green',
        errorMessage: 'Default Card set',
        openLoadingModal:false
      })
      parentThis.loadCards()
    })
    .catch( err => {
      throw new Error("Error setting default card" + err.message)
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'Error setting as default'
      })
    })
  }
  deleteCard(cardId) {
    if(this.state.creditCardsHTML && this.state.creditCardsHTML.length < 2 ){
      this.setState({
        open: true,
        color: '#c42d2d',
        errorMessage: 'You must add a new card before deleting the current one'
      })
    }
    else {
      this.setState({
        openLoadingModal: true
      })
      var parentThis = this
      this.Appt.deleteCard(cardId)
      .then( res => {
        this.setState({
          open: true,
          color: 'green',
          errorMessage: 'Successfully Deleted Card',
          openLoadingModal: false
        })
        parentThis.loadCards()
      })
      .catch( err => {
        this.setState({
          open: true,
          color: '#c42d2d',
          errorMessage: 'Error Deleting Card'
        })
      })
    }
  }
  openModal(){
    this.setState({
      openModal:true,
      open:false
    })
  }
  closeModal(){
    this.setState({
      openModal:false,
      ccErrors: ''
    })
    this.loadCards()
  }
  handleChange = name => event => {
    var value = event.target.value
     this.setState({
       [name]: value,
     })
  };
  saveCard(ccNumber, expMonth, expYear, cvc, cardName, billingZipcode) {
    this.setState({
      openModal: false,
      openLoadingModal:true
    })
    this.Appt.addCreditCard(ccNumber, expMonth, expYear, cvc, cardName, billingZipcode )
    .then(res =>{
      if(res && res.id){
        this.Appt.setDefaultCard(res.id)
        .then(res =>{
          this.loadCards()
          this.closeModal()
          this.setState({
            open: true,
            color:'green',
            openLoadingModal: false,
            errorMessage: 'Card successfully added and set as default'
          })
        })
        .catch(err =>{
          this.setState({
            openModal: true,
            openLoadingModal: false,
            color: '#c42d2d',
            errorMessage: 'Error saving card'
          })
        })
      }
      else {
        this.setState({
          openModal: true,
          openLoadingModal: false,
          ccErrors: res.errors
        })
      }
    })
    .catch(err =>{
      alert(err)
    })
  }
  render() {
    const customStyles =
    this.state.width < 780 ?
    {
      content: {
        width: '98%',
        left:'1%',
        top: '15%',
        height: '35%',
        padding: '0px !important'
      }
    }:
      {
        content: {
          width: '50%',
          left:'25%',
          top: '15%',
          height: '35%',
          padding: '0px !important'
        }
      }
    return (
      <div>
        <h3 className="dashboardHeader">Credit Cards<img className="addIcon" src={CirclePlus} onClick={this.openModal}></img></h3>
        <div className = "cardInfo">
          <p>Spiffy requires a credit card on file to schedule services. Providing your credit card allows Spiffy to confirm availability of funds as a "hold"
          If you cancel within 24 hrs of scheduled start, you may recieve a $15 fee to cover re-routing of technicians.
          </p>
        </div>
          <ul className="appointmentsList">
              {this.state.creditCardsHTML}
          </ul>
          <Modal
            isOpen={this.state.openModal}
            contentLabel="Example Modal"
            style={customStyles}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Add New Card</h4>
            </div>
            <div className="topDiv">
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={100}
                color={'#164070'}
                loading={this.state.isLoading}
              />
            </div>
              <NewCCForm ccErrors = {this.state.ccErrors} saveCard={this.saveCard} closeModal={this.closeModal}/>
          </Modal>
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
          <Modal
            isOpen={this.state.openLoadingModal}
            contentLabel="Example Modal"
            style={customStyles}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Loading</h4>
            </div>
            <div className="topDiv">
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={100}
                color={'#164070'}
                loading={this.state.openLoadingModal}
              />
            </div>
          </Modal>
      </div>
    )
  }
}
export default CreditCards



// WEBPACK FOOTER //
// ./src/Components/CreditCards.js